import { render } from "./ArtifactDetailInput.vue?vue&type=template&id=7386c13e&scoped=true&ts=true"
import script from "./ArtifactDetailInput.vue?vue&type=script&lang=ts"
export * from "./ArtifactDetailInput.vue?vue&type=script&lang=ts"

import "./ArtifactDetailInput.vue?vue&type=style&index=0&id=7386c13e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7386c13e"]])

export default __exports__